import AllCurrencies from "../components/AllCurrencies";

const Allprices = ({ currencies, isLoading }) => {
  return (
    <div className="all-prices-page">
      <AllCurrencies currencies={currencies} isLoading={isLoading} />
    </div>
  );
};
export default Allprices;
